module.exports = __webpack_public_path__ + "static/media/slider2.8e585bcf.png";